import { employeeServiceApi } from "../../app/employeeServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetDesignationDetailsResponseType,
  GetDesignationParams,
  GetDesignationsResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";

export const designationApi = employeeServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    getDesignations: builder.query<
      GetDesignationsResponseType,
      GetQueryArgsType<GetDesignationParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDesignations,
        ...queryArgs,
      }),
      providesTags: ["GetDesignations"],
    }),
    getDesignationDetails: builder.query<
      GetDesignationDetailsResponseType,
      string
    >({
      query: (id) => ({
        url: `${API_URL.getDesignationDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetDesignationDetails", id }],
    }),
    addDesignation: builder.mutation({
      query: (data) => ({
        url: API_URL.addDesignation,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetDesignations"];
        return [];
      },
    }),
    updateDesignation: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateDesignation}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetDesignations",
            {
              type: "GetDesignationDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateDesignationStatus: builder.mutation<void, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateDesignationStatus}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetDesignations",
            {
              type: "GetDesignationDetails",
              id,
            },
          ];

        return [];
      },
    }),
  }),
});

export const {
  useGetDesignationsQuery,
  useGetDesignationDetailsQuery,
  useAddDesignationMutation,
  useUpdateDesignationMutation,
  useUpdateDesignationStatusMutation,
} = designationApi;
